import AuthRoutes from './authRoutes';

export default function Public() {
  return (
    <div className="h-100">
      <AuthRoutes />
    </div>
  )
}
